/** Groups compiled wiki pages for the index: the template's fixed sections first (in order, empty ones kept), then free topics, then saved questions */

import { matchWikiTemplateSection, type WikiPageSummary, type WikiTemplateSection } from '@agentwiki/shared'

export interface WikiIndexSection {
  section: WikiTemplateSection
  pages: WikiPageSummary[]
}

export interface WikiIndex {
  sections: WikiIndexSection[]
  /** auto-generated topics in first-seen order; pages without a topic go under `fallback` */
  topics: Array<[string, WikiPageSummary[]]>
  /** saved Ask answers (kind 'question'), kept out of sections and topics */
  questions: WikiPageSummary[]
}

export function groupWikiIndex(pages: WikiPageSummary[], sections: readonly WikiTemplateSection[], fallback: string): WikiIndex {
  const bySection = new Map<string, WikiPageSummary[]>(sections.map((s) => [s.slug, []]))
  const topics = new Map<string, WikiPageSummary[]>()
  const questions: WikiPageSummary[] = []
  for (const page of pages) {
    if (page.kind === 'question') {
      questions.push(page)
      continue
    }
    const section = matchWikiTemplateSection(sections, page.topic)
    if (section) {
      bySection.get(section.slug)!.push(page)
      continue
    }
    const topic = page.topic || fallback
    topics.set(topic, [...(topics.get(topic) ?? []), page])
  }
  return {
    sections: sections.map((section) => ({ section, pages: bySection.get(section.slug) ?? [] })),
    topics: [...topics.entries()],
    questions,
  }
}
